import { Box, styled } from "@mui/material";

export const TileContent = styled(Box)(({ theme }) => ({
  padding: "0rem 0.375rem 0.375rem 0.375rem",
  boxSizing: "border-box",
}));
